import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=21146bb9&scoped=true"
import script from "./receive.vue?vue&type=script&lang=js"
export * from "./receive.vue?vue&type=script&lang=js"
import style0 from "./receive.vue?vue&type=style&index=0&id=21146bb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21146bb9",
  null
  
)

export default component.exports